<template>
  <router-view></router-view>
</template>

<script>
export default {
  created() {
    this.$store.commit('activeMenu', 'config')
    this.$store.dispatch('FETCH_USERINFO')
  }
}
</script>

<style lang="scss">
.select-wrapper,
.swap-input-wrapper {
  .v-input__slot {
    min-height: 45px !important;
  }
  .v-input__append-inner {
    margin-top: 11px;
  }
  .v-text-field__details {
    margin-bottom: 4px !important;
  }
}
.config-title {
  height: 3rem;
  width: 100%;
  text-align: center;
  font-weight: bold;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.back-svg {
  width: 16px;
  height: 16px;
}
.back-icon {
  height: 3rem !important;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 10px;
}
.panels-container {
  padding: 0 1.3rem;
  overflow: auto;
  margin: 0 auto;
  max-width: 30rem;
}
</style>
